"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.adapt2Runtime = void 0;
var utils_1 = require("./../utils");
// 将不同渠道给的 schema 转为 runtime 需要的类型
var helpers_1 = require("../helpers");
var adapt2Runtime = function (dataSource, context) {
    var interpretConfigList = dataSource.list, interpretDataHandler = dataSource.dataHandler;
    var dataHandler = interpretDataHandler
        ? utils_1.getRuntimeJsValue(interpretDataHandler, context)
        : undefined;
    // 为空判断
    if (!interpretConfigList || !interpretConfigList.length) {
        return {
            list: [],
            dataHandler: dataHandler,
        };
    }
    var list = interpretConfigList.map(function (el) {
        return {
            id: el.id,
            isInit: utils_1.getRuntimeValueFromConfig('boolean', el.isInit, context),
            isSync: utils_1.getRuntimeValueFromConfig('boolean', el.isSync, context),
            type: el.type || 'fetch',
            willFetch: el.willFetch ? utils_1.getRuntimeJsValue(el.willFetch, context) : helpers_1.defaultWillFetch,
            shouldFetch: utils_1.buildShouldFetch(el, context),
            dataHandler: el.dataHandler ? utils_1.getRuntimeJsValue(el.dataHandler, context) : helpers_1.defaultDataHandler,
            errorHandler: el.errorHandler ? utils_1.getRuntimeJsValue(el.errorHandler, context) : undefined,
            requestHandler: el.requestHandler ? utils_1.getRuntimeJsValue(el.requestHandler, context) : undefined,
            options: utils_1.buildOptions(el, context),
        };
    });
    return {
        list: list,
        dataHandler: dataHandler,
    };
};
exports.adapt2Runtime = adapt2Runtime;
